import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import staticLocalData from "../../../../constants/static_data";
import axios from 'axios'

const BajajLegalProposalForm = ({clientType, special, subSpecial, sumInsured, terri, prospect, opd, ipd,title,firstName,lastName,email,dateOfBirth,gender,houseNo,streetName,stateCode,cityCode,address,pinCode,panNumber,insuredAadhar,mobileNumber,setStep,typeOfLead}) => {
  const [allProfessionalQualifications, setAllProfessionalQualifications] =
    useState("");
  const [yearOfRegistration, setYearOfRegistration] = useState("");
  const [medicalRegistrationNumber, setMedicalRegistrationNumber] =
    useState("");
  const [averagenumberofpatients, setAveragenumberofpatients] = useState("");
  const [yearsofPractice, setYearsofPractice] = useState("");
  const [medicineBranch, setMedicineBranch] = useState("");
  const [memberOfMedicalCouncil, setMemberOfMedicalCouncil] = useState("");
  const [associationName, setAssociationName] = useState("");
  const [folioNumber, setFolioNumber] = useState("");
  const [assocnName, setAssocnName] = useState("");
  const [assocnAddress, setAssocnAddress] = useState("");
  const [assocnContact, setAssocnContact] = useState("");
  const [attachedVisitingPhysician, setAttachedVisitingPhysician] =
    useState("");
  const [attachedPhysicianDetails, setAttachedPhysicianDetails] = useState("");
  const [proposerPIHolding, setProposerPIHolding] = useState("");
  const [lastPolicyCopy, setLastPolicyCopy] = useState("");
  const [retroactiveDate, setRetroactiveDate] = useState("");
  const [legalProceedingClaims, setLegalProceedingClaims] = useState("");
  const [legalProceedingDescriptn, setLegalProceedingDescriptn] = useState("");
  const [dispensingFacilities, setDispensingFacilities] = useState("");
  const [proposerName, setProposerName] = useState("");
  const [date, setDate] = useState("");
  const [personalDeclaration, setPersonalDeclaration] = useState(false);
  const [authorizeSecurenow, setAuthorizeSecurenow] = useState(false);
  const [errors, setErrors] = useState({});
  const [buyType, setBuyType] = useState('Individual Practice')
  const [specialization, setSpecialization] = useState('')
  const [opdValue, setOpdValue] = useState()
  const [ipdValue, setIpdValue] = useState()
  const [subSpecialization, setSubSpecialization] = useState('')
  const [limitOfIndemnity, setLimitOfIndemnity] = useState('')
  const [territory, setTerritory] = useState('')
  const [premium, setPremium] = useState('')
  const [prospectId, setProspectId] = useState('')
  const [quoteId, setQuoteId] = useState('')
  const [calculatorData, setCalcData] = useState({})
  const [showExpandedCard, setShowExpandedCard] = useState(false)
  const [legalPremium, setLegalPremium] = useState()
  const [disableMailBtn, setDisableMailBtn] = useState(false)
  const [successMessage,setSuccessMessage] = useState("")
  const [isLoading,setIsLoading] = useState(false)
  
  useEffect(()=>{
    setProspectId(prospect)
    nextStep(clientType, special, subSpecial, sumInsured, terri, opd, ipd)
    if(typeOfLead==="Market Renewal"){
      setProposerPIHolding("Yes")
    }
    else{
      setProposerPIHolding("No")
    }
  },[])

  const medicalBranchList = [
    {
      id: 1,
      option: "Allopathy",
    },
    {
      id: 2,
      option: "Ayurveda",
    },
    {
      id: 3,
      option: "Homeopathy",
    },
    {
      id: 4,
      option: "Any other",
    },
  ];

  const YNList = [
    { id: 1, option: "Yes" },
    { id: 2, option: "No" },
  ];

  const nextStep = (clientType, special, subSpecial, sumInsured, terri, opd, ipd) => {
        const legal_prem = JSON.parse(localStorage.getItem("legal_premium"))
        setLegalPremium(legal_prem.premium)
        const url = '/calc/doctorProfessionalIndemnityCalc27Feb2025'
        const data = {
            "XLEW_4_4_3":clientType ? clientType : buyType,
            "_Ctrl_3":special ? special : specialization? specialization : "0",
            "XLEW_4_8_3":subSpecial ? subSpecial : subSpecialization,
            "XLEW_5_12_1":terri ? terri : territory,
            "XLEW_5_15_1":special ? special : specialization? specialization : "0",
            "XLEW_5_18_1":subSpecial ? subSpecial : subSpecialization,
            "XLEW_5_8_5":"0.804",
            "XLEW_5_9_1":sumInsured ? sumInsured : limitOfIndemnity,
            "XLEW_5_9_5":"Instant Issuance",
            "XLEW_6_10_1":0,
            "XLEW_6_13_1":0,
            "XLEW_6_16_1":"No",
            "XLEW_6_19_1":"No",
            "XLEW_6_7_1":sumInsured ? sumInsured : limitOfIndemnity
        }
        axios.post(process.env.REACT_APP_PAM_URL + url, data).then((res) => {
            const premiumVal = res.data.XLEW_5_5_12 = typeof (res.data.XLEW_5_5_12) === 'number' ? res.data.XLEW_5_5_12.toFixed(0) : res.data.XLEW_5_5_12;
            setCalcData(res.data)
            setPremium(premiumVal)
            saveQuoteData(res.data, clientType, special, subSpecial, sumInsured, terri, prospect, opd, ipd, 'unitedIndia')
        }).catch((err) => console.log(err))
   
}

const saveQuoteData = (calulatorData, clientType, special, subSpecial, sumInsured, terri, prospect, opd, ipd) => {
    const data = {
        "buyingFor": clientType? clientType : buyType,
        "specialization": special? special : specialization? specialization : "0",
        "subSpecialization": subSpecial? subSpecial : subSpecialization,
        "opdCase": (clientType === 'Hospital/Nursing/Polyclinic' ||  buyType === 'Hospital/Nursing/Polyclinic') ? opd?opd: opdValue : 0,
        "ipdCase":(clientType === 'Hospital/Nursing/Polyclinic' ||  buyType === 'Hospital/Nursing/Polyclinic') ? ipd?ipd : ipdValue : 0,
        "sumAssured0": sumInsured? sumInsured : limitOfIndemnity,
        "territoryAndJurisdiction": terri ? terri : territory,
        "radioActive0": 'covered',
        "insurerLogo": 'BajajAllianz General Insurance Company Limited',
        "netPremium":  calulatorData.XLEW_5_5_12,
        "jurisdiction": terri? terri : territory,
        "excessIndia": "NIL",
        "prospectId": prospect? prospect : prospectId ? prospectId : '',
        "quoteId": quoteId,
        "loggedInUserId": '',
        "unqualifiedStaff": "Covered",
    }
    let url = '/profession/api/v1/saveDoctorProfessionalIndemnityData'
    axios.post(process.env.REACT_APP_WEB_PAM_URL + url, data).then(res => {
        localStorage.setItem("QuoteId", res.data.data)
        setQuoteId(res.data.data)
    }).catch(err => {
        console.log(err.message)
    })
}

  const validateForm = () => {
    let temp = {};

    if (!allProfessionalQualifications.trim()) {
      temp.allProfessionalQualifications = "Enter Professional Qualifications";
    }
    if (!yearOfRegistration) {
      temp.yearOfRegistration = "Enter Year of Registration";
    }
    if (!medicalRegistrationNumber) {
      temp.medicalRegistrationNumber = "Enter Medical Registration Number";
    }
    // if (!averagenumberofpatients) {
    //   temp.averagenumberofpatients = "Enter per day patients";
    // }
    if (!yearsofPractice) {
      temp.yearsofPractice = "Enter Years of Practice";
    }
    if (!medicineBranch) {
      temp.medicineBranch = "Select Branch of Medicine";
    }

    if (!memberOfMedicalCouncil) {
      temp.memberOfMedicalCouncil = "Select Medical Council status";
    } 
    // else if (memberOfMedicalCouncil === "Yes") {
    //   if (!associationName) temp.associationName = "Select Association Name";
    //   if (!folioNumber) temp.folioNumber = "Enter Folio Number";
    //   if (!assocnName.trim()) temp.assocnName = "Enter Name";
    //   if (!assocnAddress.trim()) temp.assocnAddress = "Enter Address";
    //   if (!assocnContact || assocnContact.length !== 10)
    //     temp.assocnContact = "Enter valid 10-digit mobile";
    // }

    if (!attachedVisitingPhysician)
      temp.attachedVisitingPhysician = "Select Visiting Physician";
    // else if (attachedVisitingPhysician === "Yes") {
    //   if (!attachedPhysicianDetails.trim())
    //     temp.attachedPhysicianDetails = "Enter visiting physician details";
    // }

    if (!proposerPIHolding) temp.proposerPIHolding = "Select PI Holding";
    else if (proposerPIHolding === "Yes") {
      // if (!lastPolicyCopy) temp.lastPolicyCopy = "Attach last policy copy";
      if (!retroactiveDate) temp.retroactiveDate = "Enter retroactive date";
    }

    if (!legalProceedingClaims)
      temp.legalProceedingClaims = "Select Legal Proceeding";
    else if (legalProceedingClaims === "Yes") {
      if (!legalProceedingDescriptn.trim())
        temp.legalProceedingDescriptn = "Enter details";
    }

    if (!dispensingFacilities) temp.dispensingFacilities = "Select Facility";

    if (!proposerName.trim()) temp.proposerName = "Enter Proposer Name";
    if (!date) temp.date = "Select Date";

    if (!personalDeclaration)
      temp.personalDeclaration = "Please accept declaration";
    if (!authorizeSecurenow)
      temp.authorizeSecurenow = "Please authorize SecureNow";

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  // const handleSubmit = () => {
  //   if (validateForm()) {
  //     // submit form here
  //     console.log("Form submitted");
  //   }
  // };

  const handleSubmit = async (event, type) => {
    // event.preventDefault();
    // setShowConfirmationModal(false);
    setIsLoading(true)

    if (!validateForm()) {
      setIsLoading(false)
      return;
    }

    let requestBody = {
      title: title,
      firstName: firstName,
      // middleName: middlename,
      lastName: lastName,
      email: email,
      gender: gender,
      dateOfBirth: dateOfBirth,
      professionalQualificationsDetails: allProfessionalQualifications,
      registrationYear: yearOfRegistration,
      numberOfPatients: averagenumberofpatients,
      // sumInsured: limitofIndemnity,
      // periodOfInsuranceStartDate: policyStartDate,
      mobile: mobileNumber,
      addressee: address,
      houseNo: houseNo,
      streetName: streetName,
      city: cityCode,
      state: stateCode,
      pincode: pinCode,
      medicineBranch: medicineBranch,
      // residentialAddress: fullAddress,
      medicalRegistrationNumber: medicalRegistrationNumber,
      practiceYear: yearsofPractice,
      specialization: specialization,
      // periodOfInsuranceEndDate: policyEndDate,
      memberOfMedicalAssociation: memberOfMedicalCouncil || "No",
      memberOfMedicalAssociationName: assocnName,
      memberOfMedicalAssociationAddress: assocnAddress,
      memberOfMedicalAssociationContactNo: assocnContact,
      areYouAttached: attachedVisitingPhysician || "No",
      associationName: associationName,
      folioNumber: folioNumber,
      attachedDetails: attachedPhysicianDetails,
      prevoiusHoldAnyPolicy: proposerPIHolding || "No",
      retroactiveDate: retroactiveDate,
      lastYearPolicyAttachment: lastPolicyCopy,
      lastYearPolicyAttachmentSize: 209839,
      anyClaims: legalProceedingClaims || "No",
      anyClaimsDetails: legalProceedingDescriptn,
      authorizedSignatory: proposerName,
      proposalDeclaration: authorizeSecurenow,
      declaration: personalDeclaration,
      authorizedSignatoryDate: date,
      // authorizedSignatoryLocation: location,
      // secureNowTxnRefNo: txnRefNo,
      // agentCode: agentCode,
      panNumber: panNumber,
      aadharNumber: insuredAadhar,
      // gstNumber: gstn ? gstn : "",
      // policyType: radioVal,
      saveOrSubmit: "save",
      // healthcareProfessionalId: healthcareProfessionalId,
      prospectId: prospectId,
      quoteId: quoteId,
      facilitiesMaintained:dispensingFacilities
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_WEB_PAM_URL+ "/profession/api/v1/dpi-bajaj-proposal/save-or-submit",
        requestBody
      );

      if (response.status === 200) {    
          setSuccessMessage("Proposal Form saved Successfully");
          setTimeout(() => {
            setStep(3)
          }, 3000);
        }
    } catch (err) {
      console.error("FORM_SUBMIT_ERR:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "white",
          opacity: "50px",
          width: "80%",
          margin: "auto",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            backgroundColor: "lightgray",
            padding: "14px",
            color: "blue",
            fontWeight: "bold",
          }}
        >
          Other Details
        </div>
        <div style={{ paddingLeft: "14px", paddingRight: "14px" }}>
          <label style={{ paddingTop: "10px" }} className={"required"}>
            All Professional Qualifications and year of such qualification
          </label>
          <Input
            type="text"
            required={true}
            name={"allProfessionalQualifications"}
            placeholder={
              "All Professional Qualifications and year of such qualification"
            }
            value={allProfessionalQualifications}
            onChange={(e) => {
              setAllProfessionalQualifications(e.target.value);
              errors.allProfessionalQualifications = "";
            }}
          ></Input>
          {errors.allProfessionalQualifications && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
              {errors.allProfessionalQualifications}
            </div>
          )}
          <label style={{ paddingTop: "10px" }} className={"required"}>
            Year Of Registration
          </label>
          <Input
            type="number"
            required={true}
            name={"yearOfRegistration"}
            placeholder={"Year of Registration"}
            value={yearOfRegistration}
            min="0"
            onChange={(e) => {
              const value = e.target.value;
              if (value >= 0) {
                setYearOfRegistration(value);
              }
              errors.yearOfRegistration = "";
            }}
          ></Input>
          {errors.yearOfRegistration && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.yearOfRegistration}
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className={"required"}>
                Medical Registration
              </label>
              <Input
                type="number"
                required={true}
                name={"medicalRegistrationNumber"}
                placeholder={"Medical Registration Number"}
                value={medicalRegistrationNumber}
                min="0"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value >= 0) {
                    setMedicalRegistrationNumber(value);
                  }
                  errors.medicalRegistrationNumber = "";
                }}
              ></Input>
              {errors.medicalRegistrationNumber && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.medicalRegistrationNumber}
                </div>
              )}
            </div>
            {/* <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className={"required"}>
                Attending per day patients
              </label>
              <Input
                type="number"
                required={true}
                name={"averagenumberofpatients"}
                placeholder={"Attending per day patients"}
                value={averagenumberofpatients}
                min="0"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value >= 0) {
                    setAveragenumberofpatients(value);
                  }
                  errors.averagenumberofpatients = "";
                }}
              ></Input>
              {errors.averagenumberofpatients && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.averagenumberofpatients}
                </div>
              )}
            </div> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className={"required"}>
                Years of Practice
              </label>
              <Input
                type="number"
                required={true}
                name={"yearsofPractice"}
                placeholder={"Years of Practice"}
                value={yearsofPractice}
                min="0"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value >= 0) {
                    setYearsofPractice(value);
                  }
                  errors.yearsofPractice = "";
                }}
              ></Input>
              {errors.yearsofPractice && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.yearsofPractice}
                </div>
              )}
            </div>
            <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className="required">
                Branch of medicine
              </label>
              <Input
                type="select"
                required
                name="medicineBranch"
                value={medicineBranch}
                onChange={(e) => {
                  setMedicineBranch(e.target.value);
                  errors.medicineBranch = "";
                }}
              >
                <option value="">Select</option>
                {medicalBranchList?.map((ele, id) => (
                  <option key={id} value={ele.option}>
                    {ele.option}
                  </option>
                ))}
              </Input>
              {errors.medicineBranch && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.medicineBranch}
                </div>
              )}
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <label style={{ paddingTop: "10px" }} className="required">
              Are you a member of any Medical Association/Council?
            </label>
            <Input
              type="select"
              required
              name="memberOfMedicalCouncil"
              value={memberOfMedicalCouncil}
              onChange={(e) => {
                setMemberOfMedicalCouncil(e.target.value);
                errors.memberOfMedicalCouncil = "";
              }}
            >
              <option value="">Select</option>
              {YNList?.map((ele, id) => (
                <option key={id} value={ele.option}>
                  {ele.option}
                </option>
              ))}
            </Input>
            {errors.memberOfMedicalCouncil && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.memberOfMedicalCouncil}
              </div>
            )}
          </div>
          {/* {memberOfMedicalCouncil === "Yes" ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div style={{ width: "50%" }}>
                  <label style={{ paddingTop: "10px" }} className="required">
                    Association Name
                  </label>
                  <Input
                    type="select"
                    required
                    name="associationName"
                    value={associationName}
                    onChange={(e) => {
                      setAssociationName(e.target.value);
                      errors.associationName = "";
                    }}
                  >
                    <option value="">Select</option>
                    {staticLocalData.associationNameList?.map((ele, id) => (
                      <option key={id} value={ele.option}>
                        {ele.option}
                      </option>
                    ))}
                  </Input>
                  {errors.associationName && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.associationName}
                    </div>
                  )}
                </div>
                <div style={{ width: "50%" }}>
                  <label style={{ paddingTop: "10px" }} className={"required"}>
                    Your Folio Number
                  </label>
                  <Input
                    type="number"
                    required={true}
                    name={"folioNumber"}
                    placeholder={"Your Folio Number"}
                    value={folioNumber}
                    min="0"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value >= 0) {
                        setFolioNumber(value);
                      }
                      errors.folioNumber = "";
                    }}
                  ></Input>
                  {errors.folioNumber && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.folioNumber}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <label style={{ paddingTop: "10px" }} className="required">
                  Details of Association / Council
                </label>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ width: "33%" }}>
                    <Input
                      type="text"
                      required={true}
                      name={"assocnName"}
                      placeholder={"Name"}
                      value={assocnName}
                      onChange={(e) => {
                        setAssocnName(e.target.value);
                        errors.assocnName = "";
                      }}
                    ></Input>
                    {errors.assocnName && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {errors.assocnName}
                      </div>
                    )}
                  </div>
                  <div style={{ width: "33%" }}>
                    <Input
                      type="text"
                      required={true}
                      name={"assocnAddress"}
                      placeholder={"Address"}
                      value={assocnAddress}
                      onChange={(e) => {
                        setAssocnAddress(e.target.value);
                        errors.assocnAddress = "";
                      }}
                    ></Input>
                    {errors.assocnAddress && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {errors.assocnAddress}
                      </div>
                    )}
                  </div>
                  <div style={{ width: "33%" }}>
                    <Input
                      type="text"
                      required
                      name="assocnContact"
                      placeholder="Contact Number"
                      value={assocnContact}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) {
                          setAssocnContact(value);
                        }
                        errors.assocnContact = "";
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ".", " "].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.assocnContact && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {errors.assocnContact}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )} */}
          <div style={{ width: "100%" }}>
            <label style={{ paddingTop: "10px" }} className="required">
              Are you attached to/or attending as a visiting physician/surgeon
              in any Hospital/Nursing Home/Clinic etc.?
            </label>
            <Input
              type="select"
              required
              name="attachedVisitingPhysician"
              value={attachedVisitingPhysician}
              onChange={(e) => {
                setAttachedVisitingPhysician(e.target.value);
                errors.attachedVisitingPhysician = "";
              }}
            >
              <option value="">Select</option>
              {YNList?.map((ele, id) => (
                <option key={id} value={ele.option}>
                  {ele.option}
                </option>
              ))}
            </Input>
            {errors.attachedVisitingPhysician && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.attachedVisitingPhysician}
              </div>
            )}
          </div>
          {/* {attachedVisitingPhysician === "Yes" ? (
            <div>
              <label style={{ paddingTop: "10px" }} className="required">
                Please give details
              </label>
              <Input
                type="textarea"
                rows="3"
                required={true}
                name={"attachedPhysicianDetails"}
                placeholder={"Please Give Details"}
                value={attachedPhysicianDetails}
                onChange={(e) => {
                  setAttachedPhysicianDetails(e.target.value);
                  errors.attachedPhysicianDetails = "";
                }}
              ></Input>
              {errors.attachedPhysicianDetails && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.attachedPhysicianDetails}
                </div>
              )}
            </div>
          ) : (
            ""
          )} */}
          <div style={{ width: "100%" }}>
            <label style={{ paddingTop: "10px" }} className="required">
              Does the proposer currently hold any Professional Indemnity
              Insurance?
            </label>
            <Input
              type="select"
              required
              name="proposerPIHolding"
              value={proposerPIHolding}
              disabled={true}
              // onChange={(e) => {
              //   setProposerPIHolding(e.target.value);
              //   errors.proposerPIHolding = "";
              // }}
            >
              <option value="">Select</option>
              {YNList?.map((ele, id) => (
                <option key={id} value={ele.option}>
                  {ele.option}
                </option>
              ))}
            </Input>
            {errors.proposerPIHolding && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.proposerPIHolding}
              </div>
            )}
          </div>
          {proposerPIHolding === "Yes" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              {/* <div style={{ width: "50%" }}>
                <label style={{ paddingTop: "10px" }} className="required">
                  Attach last year policy copy
                </label>
                <div
                  style={{
                    width: "100%",
                    border: "1px solid lightgray",
                    padding: "4px",
                    borderRadius: "6px",
                  }}
                >
                  <Input
                    type="file"
                    rows="3"
                    required={true}
                    name={"lastPolicyCopy"}
                    placeholder={"Attach last year policy copy"}
                    value={lastPolicyCopy}
                    onChange={(e) => {
                      setLastPolicyCopy(e.target.value);
                      errors.lastPolicyCopy = "";
                    }}
                  ></Input>
                </div>
                {errors.lastPolicyCopy && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {errors.lastPolicyCopy}
                  </div>
                )}
              </div> */}
              <div style={{ width: "50%" }}>
                <label style={{ paddingTop: "10px" }} className="required">
                  Retroactive date as per previous policy
                </label>
                <Input
                  type="date"
                  required={true}
                  name={"retroactiveDate"}
                  placeholder={"Retroactive date as per previous policy"}
                  value={retroactiveDate}
                  onChange={(e) => {
                    setRetroactiveDate(e.target.value);
                    errors.retroactiveDate = "";
                  }}
                ></Input>
                {errors.retroactiveDate && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {errors.retroactiveDate}
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          <div style={{ width: "100%" }}>
            <label style={{ paddingTop: "10px" }} className="required">
              Have any claims been made upon you or legal proceeding instituted
              or likely to be instituted against you by patients in respect of
              your treatment etc.?
            </label>
            <Input
              type="select"
              required
              name="legalProceedingClaims"
              value={legalProceedingClaims}
              onChange={(e) => {
                setLegalProceedingClaims(e.target.value);
                errors.legalProceedingClaims = "";
              }}
            >
              <option value="">Select</option>
              {YNList?.map((ele, id) => (
                <option key={id} value={ele.option}>
                  {ele.option}
                </option>
              ))}
            </Input>
            {errors.legalProceedingClaims && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.legalProceedingClaims}
              </div>
            )}
          </div>
          {legalProceedingClaims === "Yes" ? (
            <div>
              <label style={{ paddingTop: "10px" }} className="required">
                Please give details
              </label>
              <Input
                type="textarea"
                rows="3"
                required={true}
                name={"legalProceedingDescriptn"}
                placeholder={"Please Give Details"}
                value={legalProceedingDescriptn}
                onChange={(e) => {
                  setLegalProceedingDescriptn(e.target.value);
                  errors.legalProceedingDescriptn = "";
                }}
              ></Input>
              {errors.legalProceedingDescriptn && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.legalProceedingDescriptn}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
          <div style={{ width: "100%" }}>
            <label style={{ paddingTop: "10px" }} className="required">
              Do you have any facilities such as dispensing facility/ X-ray
              Radiation therapy, scanning ECG, Sonography, MRI, etc.
              available/operated by you or under your control.
            </label>
            <Input
              type="select"
              required
              name="dispensingFacilities"
              value={dispensingFacilities}
              onChange={(e) => {
                setDispensingFacilities(e.target.value);
                errors.dispensingFacilities = "";
              }}
            >
              <option value="">Select</option>
              {YNList?.map((ele, id) => (
                <option key={id} value={ele.option}>
                  {ele.option}
                </option>
              ))}
            </Input>
            {errors.dispensingFacilities && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.dispensingFacilities}
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className="required">
                Proposer's Name:
              </label>
              <Input
                type="text"
                rows="3"
                required={true}
                name={"proposerName"}
                placeholder={"Proposer's Name:"}
                value={proposerName}
                onChange={(e) => {
                  setProposerName(e.target.value);
                  errors.proposerName = "";
                }}
              ></Input>
              {errors.proposerName && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.proposerName}
                </div>
              )}
            </div>
            <div style={{ width: "50%" }}>
              <label style={{ paddingTop: "10px" }} className="required">
                Date:
              </label>
              <Input
                type="date"
                required={true}
                name={"date"}
                placeholder={"Retroactive date as per previous policy"}
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                  errors.date = "";
                }}
              ></Input>
              {errors.date && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.date}
                </div>
              )}
            </div>
          </div>
          <div style={{ paddingTop: "10px" }}>
            <input
              type="checkbox"
              name="personalDeclaration"
              required
              checked={personalDeclaration}
              onChange={(e) => {
                setPersonalDeclaration(e.target.checked);
                errors.personalDeclaration = "";
              }}
            />

            <span style={{ fontSize: "12px", paddingLeft: "8px" }}>
              I/We do hereby declare that the above statements and answers are
              true and what I/We have not withheld any information whatsoever
              regarding the proposal. I/We hereby declare that all statutory
              provisions relating to my/our business proposed for insurance are
              complied with. I/We agree that this proposal and declarations
              shall be the basis of the contract between me/us and United India
              Whose policy for the insurance proposed is acceptable to me/us.
              I/We undertake to exercise all ordinary and reasonable precautions
              for safety of the property as if it were uninsured.
            </span>
            {errors.personalDeclaration && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.personalDeclaration}
              </div>
            )}
          </div>
          <div style={{ paddingTop: "10px" }}>
            <input
              type="checkbox"
              name="authorizeSecurenow"
              required
              checked={authorizeSecurenow}
              onChange={(e) => {
                setAuthorizeSecurenow(e.target.checked);
                errors.authorizeSecurenow = "";
              }}
            />
            <span style={{ fontSize: "12px", paddingLeft: "8px" }}>
              I/we hereby authorize SecureNow to act our exclusive insurance
              broker for placing our Professional Indemnity Policy.
            </span>
            {errors.authorizeSecurenow && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.authorizeSecurenow}
              </div>
            )}
          </div>
          {isLoading?
          <div style={{ paddingTop: "20px", paddingBottom: "20px",width:"100px",textAlign:"center" }}>
            <div
              style={{
                backgroundColor: "#3f95d5",
                color: "white",
                border: "#3f95d5",
                fontSize: "14px",
                padding: "6px 14px",
              }}
            >
              Loading...
            </div>
          </div>
          :<div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            <button
              onClick={handleSubmit}
              style={{
                backgroundColor: "#3f95d5",
                color: "white",
                border: "#3f95d5",
                fontSize: "14px",
                padding: "6px 14px",
              }}
            >
              Submit
            </button>
          </div>}
          {successMessage && (
              <div style={{ color: "green", fontSize: "12px",display:"flex",justifyContent:"center" }}>
                {successMessage}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default BajajLegalProposalForm;
